import api from '@/api/axios';
import { User } from '@/stores/store.types';

export const saveAdditionalContact = async (payload: {
  email: string;
}): Promise<{ user: User }> => {
  try {
    const { data } = await api.post('/api/users/additional-contact', payload);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const resendAdditionalContactVerificationEmail = async (): Promise<{
  user: User;
}> => {
  try {
    const { data } = await api.post(
      '/api/users/additional-contact/resend-verification',
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteAdditionalContact = async (): Promise<{ user: User }> => {
  try {
    const { data } = await api.delete('/api/users/additional-contact');
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
